import { HttpErrorResponse } from '@angular/common/http'

export function isVenueNotInServiceError(error: unknown): error is HttpErrorResponse {
    return error instanceof HttpErrorResponse && error.status === 403
}
